import { AxiosError, AxiosResponse } from 'axios';
import { useMutation, useQueryClient, UseMutationResult } from 'react-query';
import { ErrorMessage, Invoice, InvoiceCollect } from 'types';
import { client } from 'utils/api-client';

export default function useCollectInvoice(): UseMutationResult<
  AxiosResponse<Invoice>,
  AxiosError<ErrorMessage>,
  InvoiceCollect
> {
  const queryClient = useQueryClient();

  const collectInvoice = (invoice: InvoiceCollect): Promise<AxiosResponse<Invoice>> => {
    return client.post(`invoices/${invoice?.invoiceId}/collect/`, invoice);
  };

  return useMutation(collectInvoice, {
    onSuccess: () => {
      queryClient.invalidateQueries('invoices');
      queryClient.invalidateQueries('total-revenue');
      queryClient.invalidateQueries('upcoming-revenue');
      queryClient.invalidateQueries('package-revenue');
      queryClient.invalidateQueries('package-category-revenue');
      queryClient.invalidateQueries('past-due-payments');
    },
    onError: () => {
      queryClient.invalidateQueries('invoices');
      queryClient.invalidateQueries('paymentMethods');
    },
  });
}
